import * as firebase from "firebase/app";
import * as firebaseui from "firebaseui";
// NOTE: firebaseui-ja はAppleIDが出ない、、そしてこの構造だと言語の切り替えはどうするんだろう？
//       ひとまずviewでfirebaseuiを読み込んで解決とする
// import * as firebaseui_ja from "firebaseui-ja";
// import firebaseui from './npm__ja-JP';
// import "firebaseui/dist/firebaseui.css";
// import "firebaseui-ja/dist/firebaseui.css";

const firebaseConfig = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: "",
  messagingSenderId: process.env.FIREBASE_SENDER_ID,
  appName: process.env.FIREBASE_PROJECT_ID
};

firebase.initializeApp(firebaseConfig);

// export default firebase;
window.firebase = firebase;
